import React from 'react';
import { styled } from '@linaria/react';
import { Text } from '@vio/atlas/Text';
import { DEFAULT_PROVIDER_CODE, DEFAULT_PROVIDER_NAME, getProviderName } from '@daedalus/core/src/offer/business/provider';
const _exp = /*#__PURE__*/() => Text;
const StyledText = /*#__PURE__*/styled(_exp())({
  name: "StyledText",
  class: "sksr79x",
  propsAsIs: true
});
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Provider code **/
  providerCode: string;
  /** The size of the text */
  size?: 'sm' | 'md';
}
export const ProviderName = ({
  providerCode,
  size = 'md',
  className
}: Props) => {
  let providerName = getProviderName(providerCode);
  if (!providerName) {
    providerCode = DEFAULT_PROVIDER_CODE;
    providerName = DEFAULT_PROVIDER_NAME;
  }
  return <StyledText tag="span" variant={size === 'sm' ? 'bodyXS' : 'titleS'} className={className}>
      {providerName}
    </StyledText>;
};

require("./ProviderName.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ProviderName.tsx");